export const isString = function(value?: unknown): boolean {
  return typeof value === 'string';
};